// cSpell:ignore Elektriciteit
// The columns of every card in this step, the building's and each unit's
// alike (Lewis, 2026-10-16): the same headings in the same order and the
// same widths, so the cards line up under each other. A table sizes its
// columns by its own content, so each card got other widths; a fixed layout
// on these widths keeps them equal. A column that says nothing for a row
// shows "—", it is never left out.
// Sized for a 1024 px screen, where the card is about 570 px wide: each
// heading, a category ("Elektriciteit") and a date ("16/10/2026") fit on
// one line.
export const INVOICE_SELECT_COLUMNS = [
  { heading: "costs.field.category", width: "18.5%" },
  { heading: "costs.field.description", width: "18.7%" },
  { heading: "costs.field.date", width: "16.5%" },
  { heading: "costs.field.period", width: "14.8%" },
  { heading: "costs.field.distribution", width: "15.5%" },
  { heading: "costs.field.amount_excl_vat", width: "16%" },
] as const;
